const TYPOGRAPHY = {
  fonts: {
    text: 'Graphik',
    heading: 'Graphik',
    mono: 'SourceCodePro-Regular'
  },
  fontSizes: {
    xs: '0.625rem',
    sm: '0.75rem',
    md: '0.875rem',
    lg: '1.0625rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.8125rem'
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600
  }
};

export const FONTS = TYPOGRAPHY.fonts;
export const FONT_SIZES = TYPOGRAPHY.fontSizes;
export const FONT_WEIGHTS = TYPOGRAPHY.fontWeights;

export default TYPOGRAPHY;
